/**
 * Projects Components
 * 
 * Core, theme-agnostic components for property development projects.
 * These are SCORABLE components - reusable across all themes.
 */

// Original Components
export { ProjectShowcase, type ProjectShowcaseProps } from './ProjectShowcase';
export { ProjectCard, type ProjectCardProps } from './ProjectCard';
export { ProjectHeroCarousel, type ProjectHeroCarouselProps } from './ProjectHeroCarousel';
export { MagazineBannerCard, type MagazineBannerCardProps } from './MagazineBannerCard';

// Pioneering Interactive Components
export { Interactive3DProjectCard, type Interactive3DProjectCardProps } from './Interactive3DProjectCard';
export { AnimatedTimeline, type AnimatedTimelineProps, type TimelineStage } from './AnimatedTimeline';
export {
  AnimatedCounter,
  CircularProgress,
  AnimatedStatCard,
  AnimatedProgressBar,
  AnimatedComparisonChart,
  type AnimatedCounterProps,
  type CircularProgressProps,
  type AnimatedStatCardProps,
  type AnimatedProgressBarProps,
  type AnimatedComparisonChartProps,
  type ComparisonItem,
} from './InteractiveDataViz';
export { ImmersiveProjectShowcase, type ImmersiveProjectShowcaseProps } from './ImmersiveProjectShowcase';
export { AdvancedFilters, type AdvancedFiltersProps, type FilterOption } from './AdvancedFilters';
export { QuickViewModal, type QuickViewModalProps } from './QuickViewModal';
export { PioneeringProjectsGrid, type PioneeringProjectsGridProps } from './PioneeringProjectsGrid';
export { ParallaxProjectHero, type ParallaxProjectHeroProps } from './ParallaxProjectHero';
export { ProjectLocationMap, type ProjectLocationMapProps } from './ProjectLocationMap';
